<div class="modal-header" [attr.data-bs-theme]="darkModeService.darkModeSignal()">
  <h4 class="modal-title text-primary">Update Rates</h4>
  <i class="fa fa-2x fa-times text-primary" (click)="modalRef.hide()"></i>
</div>
<div class="modal-body" [attr.data-bs-theme]="darkModeService.darkModeSignal()">
  <form class="row g-3" [formGroup]="updateRatesForm">

    <div class="col-md-10">
      <label>Currency pair</label>
      <input type="text" class="form-control" formControlName="currencyPair">
    </div>

    <div class="col-md-18">
      <label>Bid</label>
      <input type="text" class="form-control" formControlName="bid">
    </div>

    <div class="col-md-18">
      <label>Offer</label>
      <input type="text" class="form-control" formControlName="offer">
    </div>

  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="modalRef.hide()">Cancel</button>
  <button type="submit" class="btn btn-primary" (click)="update()">Save Rate</button>
</div>

